<template>
    <div class="buy-content" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <!-- 页面背景 -->
        <div class="page-background">
            <div class="page-background--shadow"></div>
            <img class="page-background--image" v-if="backgroundImage" :src="backgroundImage" />
            <img class="page-background--image" v-else src="../../assets/images/bg-default.jpg" />
        </div>
        <!-- 标题 -->
        <img class="title" src="https://pdsite.partydaysport.com/official_website/buyTickets/buy-title.png">
        <!-- 步骤 -->
        <div class="step-box">
            <div class="step-item">
                <img v-if="!form.activityDate" src="../../assets/images/1.png">
                <img v-else src="../../assets/images/active-1.png">
            </div>
            <div class="step-item">
                <img v-if="!form.activityDate" src="../../assets/images/point.png">
                <img v-else src="../../assets/images/active-point.png">
            </div>
            <div class="step-item">
                <img v-if="!currrentEntryTime" src="../../assets/images/2.png">
                <img v-else src="../../assets/images/active-2.png">
            </div>
            <div class="step-item">
                <img v-if="!currrentEntryTime" src="../../assets/images/point.png">
                <img v-else src="../../assets/images/active-point.png">
            </div>
            <div class="step-item">
                <img src="../../assets/images/3.png">
            </div>
            <div class="step-item">
                <img src="../../assets/images/point.png">
            </div>
            <div class="step-item">
                <img src="../../assets/images/4.png">
            </div>
        </div>
        <!-- 门票内容 -->
        <div class="ticket-content">
            <!-- 场次预约 -->
            <div v-if="bookingInfoByMyTicket.ticketId">
                <!-- 添加购票人-->
                <div class="add-user" @click="getUserListBybooking" v-if="!currentBuyerInfo.id">
                    <i class="el-icon-circle-plus-outline"></i>
                    <span>Please add user</span>
                </div>
                <!-- 已添加的购票人列表 -->
                <div class="add-user-list" v-else>
                    <i class="el-icon-remove-outline" @click="deleteUserByBookingTicket"></i>
                    <div class="userInfo-box">
                        <div class="name">{{ currentBuyerInfo.name }}</div>
                        <div class="userInfo-number"
                            v-if="currentBuyerInfo.mobile && currentBuyerInfo.identifierNumber">
                            <div class="phone">{{ currentBuyerInfo.mobile.slice(0, 3) }}****{{
                                currentBuyerInfo.mobile.slice(7) }}
                            </div>
                            <div class="card">{{ currentBuyerInfo.identifierNumber.slice(0, 6) }}********{{
                                currentBuyerInfo.identifierNumber.slice(14) }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 门店和日期 -->
            <el-form ref="form" :model="form">
                <el-form-item style="width: 100%;" label="Store(門店)" required>
                    <el-select style="width: 100%;" v-model="form.storeId" placeholder="Please select a store"
                        @change="getDateList" :disabled="bookingInfoByMyTicket.storeId ? true : false">
                        <el-option v-for="dict in storeOptions" :key="dict.id" :label="dict.name" :value="dict.id" />
                    </el-select>
                </el-form-item>
                <div v-if="form.storeId" class="tip">Note: Only tickets within seven days can be selected , Only this
                    month and the next month can be viewed</div>
                <div v-if="form.storeId" class="tip">注意：只能選擇七天內門票，只能查看本月和下個月</div>
                <el-form-item required style="width: 100%;" label="Date(时间)" v-if="form.storeId">
                </el-form-item>
                <el-calendar ref="calendar" v-if="form.storeId" :class="{ 'active-calendar': form.storeId }"
                    :value="tempCalendarDate" @input="handleCalendarInput">
                    <template #dateCell="{ date, data }">
                        <div class="calendar-cell-wrapper" :class="{
                            'disabled-date': !getDateStatus(data.day),
                            'selected-date': form.activityDate && formatDate(form.activityDate) === data.day
                        }" @click="handleDateCellClick(data.day)">
                            <div class="custom-calendar-day" :data-status="getDateStatus(data.day)">
                                {{ data.day.split('-')[2] }}
                            </div>
                        </div>
                    </template>
                </el-calendar>
                <!-- 日历提示 -->
                <div class="calendar-tip" v-if="isPeakShow">
                    <div class="tip-item">
                        <div class="tip-circle"></div>
                        <div class="tip-text">标注圈为高峰期</div>
                    </div>
                </div>
            </el-form>
            <!-- 预约入场时间 -->
            <div class="session-group" v-if="form.activityDate">
                <div class="group-name">Select Ticket Type(請選擇票種)</div>
                <div class="session-content">
                    <div class="session-list">
                        <div class="session-title" v-for="(item, index) in showingsGroupOptions" :key="index"
                            @click="currrentShowingsGroupId = item.value; handleDateSelected()"
                            :class="{ 'active-session': currrentShowingsGroupId === item.value }"
                            v-if="shouldShowSessionGroup(item)">
                            <div class="session-cn">{{ item.label }}</div>
                            <div class="session-en">{{ item.en }}</div>
                        </div>
                    </div>
                    <div class="time-slot">
                        <div class="tip-item">
                            <div class="tip-text">请选择預約入場時間</div>
                            <div class="tip-text">
                                <div class="tip-circle"></div>粉色標註圈為熱門時段，可錯開入場時間
                            </div>
                        </div>
                        <div class="time-box">
                            <div class="time-item" v-for="(item, index) in sessionTimeSlotList" :key="index"
                                @click="handleTicketSelected(item)" :class="{
                                    'active-time': currrentEntryTime === item.entryTime,
                                    'oversold-time': !item.available,
                                    'recommend-time': item.recommend,
                                }">
                                <div class="time-text">{{ item.entryTimeText }}
                                </div>
                                <div class="oversold" v-if="!item.available">售罄</div>
                                <div class="recommend-stars" v-if="item.recommend">
                                    <img v-for="n in 3" :key="n" src="../../assets/images/star.svg" class="star-icon"
                                        :class="{ 'star-active': currrentEntryTime === item.entryTime }" alt="star">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 门票信息 -->
            <div class="ticket-list"
                v-if="ticketListByTimeSlot.length && !bookingInfoByMyTicket.ticketIdentifier && currrentEntryTime">
                <div class="ticket-box" v-for="(item, index) in ticketListByTimeSlot" :key="index"
                    v-if="shouldShowTicket(item)">
                    <div class="ticket-display">
                        <div class="half-circle">
                            <div class="circle-left"></div>
                            <div class="circle-right"></div>
                        </div>
                        <img class="image" :src="item.image">
                        <div class="ticket-right">
                            <div class="ticket-top">
                                <!-- 标题 -->
                                <div class="title">{{ item.name }}</div>
                                <div class="title">{{ item.englishName }}</div>
                            </div>
                            <!-- 添加门票数量 -->
                            <div class="ticket-detail">
                                <div class="money">￥{{ item.money }}</div>
                                <el-input-number v-model="item.ticketTotalNum"
                                    style="width:140px; scale: 0.6;margin-right: -40px;padding-right: 40px;"
                                    :min="0"></el-input-number>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="nodata-tip">-到底啦-</div>
            </div>
            <!-- 提示语 -->
            <div class="nodata-tip ticket-tip" v-if="form.storeId && form.activityDate">
                <span v-if="!sessionTimeSlotList.length">-当前日期沒有預約入場時間，請重新選擇-</span>
                <span
                    v-if="currrentEntryTime && !ticketListByTimeSlot.length && !this.bookingInfoByMyTicket.ticketIdentifier">-該預約入場時間沒有票種，請重新選擇-</span>
            </div>
        </div>
        <div class="dialog-footer">
            <el-button class="return-btn" type="primary" plain @click="goBack">
                <div class="cn">返回</div>
                <div class="en">Return</div>
            </el-button>
            <el-button type="primary" v-if="bookingInfoByMyTicket.ticketIdentifier && !bookingInfoByMyTicket.ticketId"
                @click="rescheduleTicket" class="save-btn">
                <div class="confirm-btn">
                    <div>
                        <div class="cn">預約改期</div>
                        <div class="en">Reschedule Booking</div>
                    </div>
                </div>
            </el-button>
            <el-button type="primary" v-if="bookingInfoByMyTicket.ticketIdentifier && bookingInfoByMyTicket.ticketId"
                @click="appointmentTicketAddUser">
                <div class="confirm-btn">
                    <div>
                        <div class="cn">場次選擇</div>
                        <div class="en">Select Session</div>
                    </div>
                </div>
            </el-button>
            <!-- PC端 -->
            <el-button class="btn-pc" type="primary" v-if="!bookingInfoByMyTicket.ticketIdentifier"
                @click="buyTicketClick" :disabled="isRestoring || loading">
                <div class="confirm-btn">
                    <div class="totalMoney" v-if="totalMoney">￥{{ totalMoney }}</div>
                    <div>
                        <div class="cn">確認</div>
                        <div class="en">confirm</div>
                    </div>
                </div>
            </el-button>
            <!-- 手机端 -->
            <el-button class="btn-mobile" type="primary" v-if="!bookingInfoByMyTicket.ticketIdentifier"
                @click="buyTicketClick" :disabled="isRestoring || loading">
                <div class="confirm-btn">
                    <div class="totalMoney" v-if="totalMoney">￥{{ totalMoney }}</div>
                    <div>
                        <div class="cn">確認</div>
                        <div class="en">confirm</div>
                    </div>
                </div>
            </el-button>
        </div>
        <!-- 购票人管理弹窗 -->
        <div class="popup-content" v-if="isPopupUser" @click="cancelPopupUser">
            <div class="popup-box popup-user" @click.stop>
                <!-- 添加购票人 -->
                <div class="add-user" @click="handleAdd">
                    <i class="el-icon-circle-plus-outline"></i>
                    <span>Please add user</span>
                </div>
                <!-- 购票人列表 -->
                <div class="user-list">
                    <div class="user-singel" v-for="(item, index) in userList" :key="index">
                        <div class="user-info">
                            <div class="user-tag name">{{ item.name }}</div>
                            <div class="user-tag phone">{{ item.mobile.slice(0, 3) }}****{{ item.mobile.slice(7) }}
                            </div>
                            <div class="user-tag card">{{ item.identifierNumber.slice(0, 6) }}********{{
                                item.identifierNumber.slice(14) }}</div>
                        </div>
                        <div class="action-btn">
                            <div class="btn" @click="addUserForTicket(item)">選擇</div>
                            <div class="btn" @click="updateUserForTicket(item.id)">修改</div>
                            <div class="btn" @click="removeUserForTicket(item)">删除</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 添加或修改用户信息对话框 -->
        <el-dialog class="add-user-dialog" :title="title" :visible.sync="open" append-to-body
            :close-on-click-modal="false">
            <el-form ref="formUser" :model="formUser" :rules="rulesUser" label-width="80px">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="formUser.name" placeholder="Please Enter Full Name" />
                </el-form-item>
                <el-form-item label="手機號" prop="mobile">
                    <el-input v-model="formUser.mobile" placeholder="Please Enter Mobile Phone Number" />
                </el-form-item>
                <el-form-item label="證件類型" prop="identifierType">
                    <el-select style="width: 100%;" v-model="formUser.identifierType"
                        placeholder="Please Select The Type Of Identification Document" clearable filterable>
                        <el-option v-for="dict in typeOptions" :key="dict.value" :label="dict.label"
                            :value="dict.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="證件號碼" prop="identifierNumber">
                    <el-input v-model="formUser.identifierNumber"
                        placeholder="Please Enter Your Identification Number" />
                </el-form-item>
                <el-form-item label="性别" prop="sex">
                    <el-radio-group v-model="formUser.sex">
                        <el-radio v-for="dict in sexOptions" :key="dict.value" :label="dict.value"
                            :aria-hidden="false">{{
                                dict.label }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="生日" prop="birthday">
                    <el-date-picker style="width: 100%;" v-model="formUser.birthday" type="date"
                        value-format="yyyy-MM-dd" placeholder="Please Select A Date">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="user-footer">
                <el-button type="primary" @click="submitForm">確定</el-button>
                <el-button type="primary" plain @click="cancel">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { isWorkday } from 'chinese-days';
import QRCode from 'qrcodejs2'
import {
    storeList,
    addBuyer,
    editBuyer,
    delBuyer,
    listBuyer,
    detailsBuyer,
    rebookTicketV3,
    reservationTicketv3,
    activityShowingsDateList,
    getEntryTimesList,
    getAvailableList
} from "@/api/activity";
export default {
    name: 'buy',
    data() {
        return {
            // 表单参数
            form: {},
            storeOptions: [],//门店列表
            bookingInfoByMyTicket: {},//改约/预约的门票内容
            currentBuyerInfo: {},//预约绑定的购票人
            loading: false, // 加载状态
            calendarOptions: [],//日历列表
            sessionTimeSlotList: [],//场次预约情况列表
            currrentShowingsGroupId: 2,//当前选择的场次分组 1.2小时场 2.4小时场 3.全天
            showingsGroupOptions: [{
                label: '4小時門票',
                en: '4H TICKETS',
                value: 2
            }, {
                label: '2小時門票',
                en: '2H TICKETS',
                value: 1
            }, {
                label: '全天',
                en: 'ALL DAY',
                value: 3
            }],//场次分组选项
            currrentEntryTime: null,//当前选择预约入场时间
            ticketListByTimeSlot: [],//门票列表
            backgroundImage: "",//背景图片
            tempCalendarDate: null, // 临时日历日期，仅用于显示
            lastSelectedDate: null, // 记录最后选中的日期
            currentMonth: null, // 当前显示的月份
            isPaySuccess: false,//是否支付成功
            timeSlotText: "",//时段，确认订单页面显示
            isRestoring: false, // 标记是否正在恢复数据
            pendingRestoreData: null, // 待恢复的数据
            formUser: {},
            // 表单校验
            rulesUser: {
                name: [{ required: true, message: "Please Enter Full Name", trigger: "blur" }],
                mobile: [{ required: true, message: "Please Enter Mobile Phone Number", trigger: "blur" }],
                identifierType: [{ required: true, message: "Please Select The Type Of Identification Document", trigger: "change" }],
                identifierNumber: [{ required: true, message: "Please Enter Your Identification Numbe", trigger: "blur" }],
                sex: [{ required: true, message: "Please Select Gender", trigger: "change" }],
                birthday: [{ required: true, message: "Please Select A Date", trigger: "blur" }],
            },
            typeOptions: [{
                label: "身份證",
                value: '01'
            }, {
                label: "護照",
                value: '02'
            }, {
                label: "軍人證",
                value: '03'
            }, {
                label: "駕照",
                value: '04'
            }, {
                label: "港澳回鄉證",
                value: '05'
            }, {
                label: "臺胞證",
                value: '07'
            }],//证件类型
            sexOptions: [{
                label: "男",
                value: 1
            }, {
                label: "女",
                value: 2
            }],//性别
            isPopupUser: false,//购票人信息弹窗
            open: false,
            title: "",
            userList: [],//购票人信息
        }
    },
    computed: {
        // 修改参数
        ticketTime() {
            switch (this.currrentShowingsGroupId) {
                case 1:
                    return 120;  // 1.2小时场
                case 2:
                    return 240;  // 2.4小时场
                case 3:
                    return 0;    // 全天
                default:
                    return 0;
            }
        },
        // 共计交易金额
        totalMoney() {
            let sum = 0;
            this.ticketListByTimeSlot.forEach(item => {
                sum += (item.ticketTotalNum * item.money);
            });
            return sum;
        },
        // 是否现在高峰期
        isPeakShow() {
            return this.calendarOptions.some(item => item.status === 2);
        }
    },
    //监听门店切换，确保状态完全重置
    watch: {
        'form.storeId': {
            handler(newVal, oldVal) {
                // 如果正在恢复数据，不执行重置
                if (this.isRestoring) {
                    return;
                }
                if (newVal && newVal !== oldVal) {
                    // 门店切换时，完全重置所有相关状态
                    this.resetAllSelectData();
                    this.calendarOptions = [];
                    this.sessionTimeSlotList = [];
                    this.ticketListByTimeSlot = [];
                    this.currrentEntryTime = null;
                    this.currrentShowingsGroupId = 2;

                    // 重置日历显示
                    this.initMonthRange();

                    // 强制刷新日历组件
                    this.$nextTick(() => {
                        if (this.$refs.calendar) {
                            this.$refs.calendar.$forceUpdate();
                        }
                    });
                }
            },
            immediate: false
        }
    },
    mounted() {
        // 先初始化基础数据
        this.initMonthRange();
        // 检查是否有暂存的门票信息（从pay页面返回时）
        const savedTicketInfo = sessionStorage.getItem('buyTicketInfo');
        if (savedTicketInfo) {
            try {
                this.pendingRestoreData = JSON.parse(savedTicketInfo);
                this.isRestoring = true;
            } catch (e) {
                console.log('解析门票信息失败:', e);
                sessionStorage.removeItem('buyTicketInfo');
            }
        }
        // 获取门店列表
        this.getStoreList();

        // 改约门票号/预约时间
        if (this.$route.query.ticketIdentifier) {
            this.bookingInfoByMyTicket = this.$route.query;
            this.form.storeId = Number(this.$route.query.storeId);
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.clearValidate();
                }
                this.getDateList();
            });
        }

        // 监听日历DOM变化，确保按钮状态正确
        this.unwatchTempCalendarDate = this.$watch('tempCalendarDate', () => {
            this.updateButtonDisabledState();
        });

        // 初始更新按钮状态
        this.$nextTick(() => {
            this.updateButtonDisabledState();
        });

        // 监听日历组件的月份切换完成事件
        if (this.$refs.calendar) {
            const calendarEl = this.$refs.calendar.$el;
            if (calendarEl) {
                // 使用 MutationObserver 监听日历内容变化
                const observer = new MutationObserver(() => {
                    this.updateButtonDisabledState();
                });
                observer.observe(calendarEl, { childList: true, subtree: true });
                this.calendarObserver = observer;
            }
        }

        // 监听路由变化，处理从pay页面返回
        this.$router.afterEach((to, from) => {
            if (from.path === '/pay' && to.path === '/buy') {
                // 从pay页面返回时，延迟恢复数据
                setTimeout(() => {
                    this.handlePayPageReturn();
                }, 300);
            }
        });
    },

    beforeDestroy() {
        if (this.unwatchTempCalendarDate) {
            this.unwatchTempCalendarDate();
        }
        // 清理 observer
        if (this.calendarObserver) {
            this.calendarObserver.disconnect();
        }
    },
    methods: {
        shouldShowSessionGroup(item) {
            // 如果没有限制条件，显示所有
            if (!this.bookingInfoByMyTicket?.currrentShowingsGroupId) {
                return true;
            }
            // 有限制条件时，只显示匹配的场次分组
            return this.bookingInfoByMyTicket.currrentShowingsGroupId == item.value;
        },
        // 判断门票是否应该显示
        shouldShowTicket(item) {
            if (!this.form.activityDate) return false;

            const isWorkDay = isWorkday(this.formatDate(this.form.activityDate));
            const useTime = item.useTime;

            switch (useTime) {
                case 1: return true;     // 不限制
                case 2: return isWorkDay === true;   // 工作日
                case 3: return isWorkDay === false;  // 节假日
                case 4: return true;     // 夜场
                default: return false;
            }
        },
        // 返回
        goBack() {
            this.$router.back()
        },
        // 初始化月份范围
        initMonthRange() {
            const now = new Date();
            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth();
            // 最小日期：当月1号（只比较年月，不比较日）
            this.minDate = new Date(currentYear, currentMonth, 1);
            // 最大日期：下个月1号
            this.maxDate = new Date(currentYear, currentMonth + 1, 1);
            // 设置当前显示为当月
            this.tempCalendarDate = new Date(currentYear, currentMonth, 1);
            this.currentMonth = new Date(currentYear, currentMonth, 1);
        },
        // 处理日历输入变化
        handleCalendarInput(newDate) {
            if (!newDate) return;
            const now = new Date();
            const nowYear = now.getFullYear();
            const nowMonth = now.getMonth();
            const targetYear = newDate.getFullYear();
            const targetMonth = newDate.getMonth();
            // 检查是否在允许的范围内
            if (targetYear < nowYear || (targetYear === nowYear && targetMonth < nowMonth)) {
                this.showMonthLimitWarning(nowYear, nowMonth);
                return;
            }
            if (targetYear > nowYear || (targetYear === nowYear && targetMonth > nowMonth + 1)) {
                this.showMonthLimitWarning(nowYear, nowMonth + 1);
                return;
            }
            // 允许切换
            this.currentMonth = new Date(targetYear, targetMonth, 1);
            this.tempCalendarDate = new Date(targetYear, targetMonth, 1);
            this.updateButtonDisabledState();
        },
        // 提取警告提示方法
        showMonthLimitWarning(year, month) {
            this.$notify({
                title: '只能查看本月和下個月',
                type: 'warning',
                duration: 1000
            });
            this.tempCalendarDate = new Date(year, month, 1);
            this.currentMonth = new Date(year, month, 1);
            this.updateButtonDisabledState();
        },
        // 更新按钮禁用状态
        updateButtonDisabledState() {
            // 使用 requestAnimationFrame 确保 DOM 更新完成
            requestAnimationFrame(() => {
                const calendarEl = this.$refs.calendar?.$el;
                if (!calendarEl) return;
                const prevBtn = calendarEl.querySelector('.el-calendar__button-group .el-button-group button:first-child');
                const nextBtn = calendarEl.querySelector('.el-calendar__button-group .el-button-group button:last-child');
                const now = new Date();
                const nowYear = now.getFullYear();
                const nowMonth = now.getMonth();
                // 获取当前显示的年月，如果 currentMonth 为空则使用默认值
                let currentYear = nowYear;
                let currentMonth = nowMonth;
                if (this.currentMonth) {
                    currentYear = this.currentMonth.getFullYear();
                    currentMonth = this.currentMonth.getMonth();
                }
                if (prevBtn) {
                    const isCurrentMonth = (currentYear === nowYear && currentMonth === nowMonth);
                    prevBtn.disabled = isCurrentMonth;
                    if (isCurrentMonth) {
                        prevBtn.classList.add('disabled');
                        prevBtn.setAttribute('disabled', 'disabled');
                    } else {
                        prevBtn.classList.remove('disabled');
                        prevBtn.removeAttribute('disabled');
                    }
                }
                if (nextBtn) {
                    const isNextMonth = (currentYear === nowYear && currentMonth === nowMonth + 1);
                    nextBtn.disabled = isNextMonth;
                    if (isNextMonth) {
                        nextBtn.classList.add('disabled');
                        nextBtn.setAttribute('disabled', 'disabled');
                    } else {
                        nextBtn.classList.remove('disabled');
                        nextBtn.removeAttribute('disabled');
                    }
                }
            });
        },
        // 账户过期处理
        message405(res) {
            if (res.data.code == 405) {
                this.$notify({
                    title: '帳號過期請重新登入',
                    type: 'error'
                });
                localStorage.removeItem('satoken')
                this.$router.replace('/')
            } else {
                this.$notify({
                    title: res.data.message || res.data.msg,
                    type: 'error'
                });
            }
        },
        // 获取门店列表
        getStoreList() {
            this.loading = true
            return storeList()
                .then((res) => {
                    if (res.data.code == 200) {
                        this.storeOptions = res.data.data
                        // 门店列表加载完成后，如果有待恢复的数据，执行恢复
                        if (this.pendingRestoreData && this.isRestoring) {
                            this.$nextTick(() => {
                                this.restoreTicketInfoAfterStoreLoaded();
                            });
                        }
                    } else {
                        this.message405(res)
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 重置所有选择数据（门店、日期、场次分组、场次、门票列表）
        resetAllSelectData() {
            this.form.activityDate = undefined;//重置日期
            this.sessionTimeSlotList = [];//重置场次列表
            this.currrentShowingsGroupId = 2;//重置场次分组
            this.ticketListByTimeSlot = [];//重置场次列表
            this.currrentEntryTime = null;
            this.lastSelectedDate = null; // 重置最后选中的日期
            this.tempCalendarDate = null; // 重置临时日期
        },
        // 获取获取场次日历
        getDateList() {
            if (!this.form.storeId) {
                // 如果是恢复数据过程中，不要弹出提示
                if (!this.isRestoring) {
                    this.$notify({
                        title: '請先選擇門店',
                        type: 'warning'
                    });
                }
                return Promise.reject('请先选择门店');
            }
            this.resetAllSelectData()
            this.initMonthRange(); // 初始化月份范围
            this.loading = true

            return activityShowingsDateList({
                storeId: this.form.storeId
            })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.calendarOptions = res.data.data.slice(0, 7);

                        // 数据加载完成后，强制刷新日历视图
                        this.$nextTick(() => {
                            // 触发日历重新渲染
                            if (this.$refs.calendar) {
                                const currentValue = this.tempCalendarDate;
                                this.tempCalendarDate = null;
                                this.$nextTick(() => {
                                    this.tempCalendarDate = currentValue;
                                });
                            }
                            this.updateButtonDisabledState();
                            // 清除验证状态
                            if (this.$refs.form) {
                                this.$refs.form.clearValidate();
                            }
                        });
                    } else {
                        this.message405(res);
                        return Promise.reject(res);
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 获取指定日期的状态
        getDateStatus(day) {
            if (!this.calendarOptions.length) return 0;
            const found = this.calendarOptions.find(item => item.startTime === day);
            if (!found) return 0;
            // status: 2 保持为 2（高峰期），其他可用状态统一为 1
            return found.status === 2 ? 2 : 1;
        },
        // 只有有效日期才能选中
        handleDateCellClick(day) {
            // 如果正在恢复数据，忽略点击
            if (this.isRestoring) {
                return;
            }
            // 确保日历数据已加载
            if (!this.calendarOptions.length) {
                this.$notify({
                    title: '日曆數據加載中，請稍後',
                    type: 'warning',
                    duration: 1000
                });
                return;
            }

            const status = this.getDateStatus(day);
            if (!status) {
                this.$notify({
                    title: '該日期不可選',
                    type: 'warning',
                    duration: 1000
                });
                return;
            }

            const newDate = new Date(day);
            const formattedNewDate = this.formatDate(newDate);
            const formattedLastDate = this.lastSelectedDate ? this.formatDate(this.lastSelectedDate) : null;

            // 避免重复选择同一个日期
            if (this.lastSelectedDate && formattedNewDate === formattedLastDate) {
                return;
            }

            // 确保日期有效且状态正确后再更新
            this.form.activityDate = newDate;
            this.lastSelectedDate = newDate;

            if (this.bookingInfoByMyTicket && this.bookingInfoByMyTicket.currrentShowingsGroupId) {
                this.currrentShowingsGroupId = Number(this.bookingInfoByMyTicket.currrentShowingsGroupId);
            } else {
                this.currrentShowingsGroupId = 2;
            }

            // 添加一个小延迟，确保状态更新完成后再执行后续逻辑
            this.$nextTick(() => {
                this.handleDateSelected();
            });
        },
        // 获取场次信息及预约情况
        handleDateSelected() {
            //确保有有效的日期
            if (!this.form.activityDate) {
                return;
            }
            // 重置
            this.currrentEntryTime = null;
            this.ticketListByTimeSlot = []
            this.loading = true
            getEntryTimesList({
                storeId: this.form.storeId,
                bookingDate: this.formatDate(this.form.activityDate),
                ticketDurationMinutes: this.ticketTime//单位分钟，0表示全天
            }).then(res => {
                if (res.data.code == 200) {
                    this.sessionTimeSlotList = res.data.data
                    if (!this.sessionTimeSlotList.length) {
                        this.$notify({
                            title: '當前日期沒有預約入場時間，請重新選擇',
                            type: 'warning',
                            duration: 2000
                        });
                    }
                    //获取门票列表
                    if (!this.isRestoring) {
                        this.queryAvailableList()
                    }
                    this.scrollTop()
                } else {
                    this.message405(res)
                }
            })
                .finally(() => {
                    this.loading = false

                    // 如果是恢复数据，在数据加载完成后恢复门票列表和场次
                    if (this.isRestoring && this.pendingRestoreData) {
                        const ticketInfo = this.pendingRestoreData;
                        // 恢复门票列表
                        if (ticketInfo.ticketList) {
                            this.ticketListByTimeSlot = ticketInfo.ticketList.map(ticket => ({
                                ...ticket,
                                ticketTotalNum: ticket.ticketTotalNum || 0
                            }));
                        }
                        // 恢复场次
                        if (ticketInfo.entryTime) {
                            // 检查恢复的场次是否在当前的 sessionTimeSlotList 中
                            const exists = this.sessionTimeSlotList.some(item => item.entryTime === ticketInfo.entryTime);
                            if (exists) {
                                this.currrentEntryTime = ticketInfo.entryTime;
                                this.timeSlotText = ticketInfo.timeSlotText || '';
                            } else {
                                // 如果场次不存在，重置
                                this.currrentEntryTime = null;
                                this.timeSlotText = '';
                            }
                        }

                        // 恢复完成后，清除验证错误和状态
                        this.$nextTick(() => {
                            if (this.$refs.form) {
                                this.$refs.form.clearValidate();
                            }
                            this.isRestoring = false;
                            this.pendingRestoreData = null;
                            sessionStorage.removeItem('buyTicketInfo');
                            //恢复完成后滚动到门票列表区域
                            this.scrollToTicketList();
                        });
                    }
                })
        },
        // 滚动到门票列表区域
        scrollToTicketList() {
            this.$nextTick(() => {
                // 优先滚动到门票列表
                const ticketList = document.querySelector('.ticket-list');
                if (ticketList && ticketList.children.length > 0) {
                    ticketList.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                    return;
                }

                // 如果没有门票列表，滚动到场次分组区域
                const sessionGroup = document.querySelector('.session-group');
                if (sessionGroup) {
                    sessionGroup.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                    return;
                }

                // 如果都没有，滚动到日历区域
                const calendar = document.querySelector('.el-calendar');
                if (calendar) {
                    calendar.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        },
        // 根据门店和票时长获取可购买门票列表
        queryAvailableList() {
            // 改约不需要加载门票信息
            if (this.bookingInfoByMyTicket.ticketIdentifier) return
            this.loading = true
            getAvailableList({
                storeId: this.form.storeId,
                ticketDurationMinutes: this.ticketTime
            }).then(res => {
                if (res.data.code == 200) {
                    this.ticketListByTimeSlot = res.data.data.map(ticket => ({
                        ...ticket,
                        ticketTotalNum: 0,  // 门票数量
                    }));
                } else {
                    this.message405(res)
                }
            })
                .finally(() => {
                    this.loading = false
                })
        },
        // 门票列表
        handleTicketSelected(item) {
            // 防止重复点击同一个时间
            if (item.entryTime === this.currrentEntryTime) {
                return;
            }
            if (!item.available) {
                this.$notify({
                    title: '該时间已售完',
                    type: 'warning',
                    duration: 1000
                });
                return;
            }
            // this.backgroundImage = item.image//背景图片
            this.currrentEntryTime = item.entryTime;
            this.timeSlotText = item.entryTimeText
            this.scrollTop()
        },
        // 数据加载完成后，滚动到场次分组区域
        scrollTop() {
            this.$nextTick(() => {
                const sessionGroup = document.querySelector('.session-group');
                if (sessionGroup) {
                    sessionGroup.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        },
        // 格式化日期
        formatDate(date) {
            if (!date) return null;
            // 确保 date 是 Date 对象
            const d = date instanceof Date ? date : new Date(date);
            if (isNaN(d.getTime())) return null;
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        // 购买
        buyTicketClick() {
            // 如果正在恢复数据，不执行验证
            if (this.isRestoring) {
                this.$notify({
                    title: '數據正在恢復中，請稍後',
                    type: 'warning',
                    duration: 1000
                });
                return;
            }
            // 判断门店
            if (!this.form.storeId) {
                this.$notify({
                    title: '請選擇門店',
                    type: 'warning',
                    duration: 2000
                });
                return
            }
            // 判断日期
            if (!this.form.activityDate) {
                this.$notify({
                    title: '請選擇日期',
                    type: 'warning',
                    duration: 2000
                });
                return
            }
            // 判断场次                    
            if (!this.sessionTimeSlotList.length) {
                this.$notify({
                    title: '當前日期沒有預約入場時間，請重新選擇',
                    type: 'warning',
                    duration: 2000
                });
                return
            }
            if (!this.currrentEntryTime) {
                this.$notify({
                    title: '請選擇預約入場時間',
                    type: 'warning',
                    duration: 2000
                });
                return
            }
            // 判断是否选择门票
            const totalNum = this.ticketListByTimeSlot.reduce((total, item) => total + item.ticketTotalNum, 0);
            if (!totalNum) {
                this.$notify({
                    title: '請選擇門票',
                    type: 'warning',
                    duration: 2000
                });
                return
            }

            // 发起门票活动交易
            this.confirmOrder()
        },
        // 处理从pay页面返回
        handlePayPageReturn() {
            const savedTicketInfo = sessionStorage.getItem('buyTicketInfo');
            if (savedTicketInfo) {
                try {
                    this.pendingRestoreData = JSON.parse(savedTicketInfo);
                    this.isRestoring = true;
                    // 如果门店列表已加载，立即恢复
                    if (this.storeOptions.length > 0) {
                        this.restoreTicketInfoAfterStoreLoaded();
                    }
                } catch (e) {
                    console.log('解析门票信息失败:', e);
                    sessionStorage.removeItem('buyTicketInfo');
                }
            }
        },
        // 门店列表加载完成后恢复数据
        restoreTicketInfoAfterStoreLoaded() {
            if (!this.pendingRestoreData) return;

            const ticketInfo = this.pendingRestoreData;

            // 恢复门店
            if (ticketInfo.storeId) {
                this.form.storeId = ticketInfo.storeId;

                // 清除验证状态
                this.$nextTick(() => {
                    if (this.$refs.form) {
                        this.$refs.form.clearValidate();
                    }
                });

                // 重新加载日期列表
                this.getDateList().then(() => {
                    // 恢复日期
                    if (ticketInfo.activityDate) {
                        const dateObj = new Date(ticketInfo.activityDate);
                        this.form.activityDate = dateObj;
                        this.lastSelectedDate = dateObj;
                        this.tempCalendarDate = dateObj;

                        // 恢复场次分组
                        if (ticketInfo.currrentShowingsGroupId) {
                            this.currrentShowingsGroupId = ticketInfo.currrentShowingsGroupId;
                        }

                        // 调用 handleDateSelected 获取场次信息
                        this.$nextTick(() => {
                            if (this.$refs.form) {
                                this.$refs.form.clearValidate();
                            }
                            // 调用获取场次信息
                            this.handleDateSelected();
                        });
                    } else {
                        this.isRestoring = false;
                        this.pendingRestoreData = null;
                        // 恢复完成，滚动到日历区域
                        this.scrollToTicketList();
                    }
                }).catch(() => {
                    this.isRestoring = false;
                    this.pendingRestoreData = null;
                    // 恢复失败，滚动到日历区域
                    this.scrollToTicketList();
                });
            } else {
                this.isRestoring = false;
                this.pendingRestoreData = null;
                // 恢复完成，滚动到日历区域
                this.scrollToTicketList();
            }
        },
        // 确认订单
        confirmOrder() {
            // 存储订单信息用于展示
            const orderInfo = {
                storeId: this.form.storeId,
                storeName: this.storeOptions.find(store => store.id == this.form.storeId)?.name,
                timeSlotText: this.timeSlotText,
                backgroundImage: this.backgroundImage,
                ticketBuyerList: this.ticketListByTimeSlot,//购票人列表
                entryTime: this.currrentEntryTime,//预约入场时间
                activityDate: this.formatDate(this.form.activityDate),//预约时间
                ticketDurationMinutes: this.ticketTime,//票时长，单位分钟，0表示全天
            };
            localStorage.setItem('orderInfo', JSON.stringify(orderInfo));

            // 存储门票选择信息到sessionStorage，用于返回时恢复
            const ticketInfo = {
                storeId: this.form.storeId,
                activityDate: this.formatDate(this.form.activityDate),
                currrentShowingsGroupId: this.currrentShowingsGroupId,
                entryTime: this.currrentEntryTime,
                timeSlotText: this.timeSlotText,
                ticketList: this.ticketListByTimeSlot.map(ticket => ({
                    ...ticket,
                    ticketTotalNum: ticket.ticketTotalNum || 0
                }))
            };
            sessionStorage.setItem('buyTicketInfo', JSON.stringify(ticketInfo));
            this.$router.push({
                path: '/pay'
            });
        },
        // 判断条件
        isPassByJudgingCondition() {
            if (!this.form.activityDate) {
                this.$notify({
                    title: '還未選擇日期~',
                    type: 'warning',
                    duration: 2000
                });
                return false
            }

            if (!this.currrentEntryTime) {
                this.$notify({
                    title: '還未選擇预约入场时间~',
                    type: 'warning',
                    duration: 2000
                });
                return false
            }

            return true
        },
        // 预约改期
        rescheduleTicket() {
            if (!this.isPassByJudgingCondition()) {
                return
            }
            this.rebookTicket()
        },
        // 确认改签
        rebookTicket() {
            this.$confirm('是否確認改約的预约入场时间為: ' + this.currrentEntryTime + '?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true
                rebookTicketV3({
                    ticketIdentifier: this.bookingInfoByMyTicket.ticketIdentifier,//门票
                    entryTime: this.currrentEntryTime,//预约入场时间
                }).then((res) => {
                    if (res.data.code == 200) {
                        this.bookingInfoByMyTicket = {}
                        this.$notify({
                            title: '改約成功',
                            type: 'success',
                            duration: 2000
                        });
                        this.goBack()
                    } else {
                        this.message405(res)
                    }
                }).finally(() => {
                    this.loading = false
                })
            })
        },
        // 点击场次预约
        appointmentTicketAddUser() {
            if (!this.currentBuyerInfo.id) {
                this.$notify({
                    title: '請添加購票人資訊~',
                    type: 'warning',
                    duration: 2000
                });
                return
            }
            if (!this.isPassByJudgingCondition()) {
                return
            }
            this.appointmentTicketFun()
        },
        // 确认预约
        appointmentTicketFun() {
            this.$confirm('是否確認選擇的预约入场时间為: ' + this.currrentEntryTime + '?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true
                reservationTicketv3({
                    storeId: this.bookingInfoByMyTicket.storeId,//门店ID
                    entryTime: this.currrentEntryTime,//预约入场时间
                    ticketDurationMinutes: this.ticketTime,//票时长，单位分钟，0表示全天
                    ticketId: this.bookingInfoByMyTicket.ticketId,
                    buyerId: this.currentBuyerInfo.id,//预约人ID
                    ticketIdentifier: this.bookingInfoByMyTicket.ticketIdentifier,
                    payType: 2,
                    bookingChannel: 3,//预约渠道——网站
                }).then((res) => {
                    if (res.data.code == 200) {
                        this.bookingInfoByMyTicket = {}
                        this.$notify({
                            title: '預約成功',
                            type: 'success',
                            duration: 2000
                        });
                        this.goBack()
                    } else {
                        this.message405(res)
                    }
                }).finally(() => {
                    this.loading = false
                })
            })
        },
        // 获取购票人列表
        getUserList(index) {
            this.currentTicketIndex = index
            this.isPopupUser = true
            this.getList()
        },
        getUserListBybooking() {
            this.isPopupUser = true
            this.getList()
        },
        deleteUserByBookingTicket() {
            this.currentBuyerInfo = {}
        },
        // 关闭购票人弹窗
        cancelPopupUser() {
            this.isPopupUser = false
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.resetUser();
        },
        // 表单重置
        resetUser() {
            this.formUser = {
                id: undefined,
                name: undefined,
                mobile: undefined,
                identifierType: undefined,
                identifierNumber: undefined,
                sex: undefined,
                birthday: undefined,
            };
            this.resetForm("formUser");
        },
        resetForm(refName) {
            if (this.$refs[refName]) {
                this.$refs[refName].resetFields();
            }
        },
        // 购票人列表
        getList() {
            listBuyer()
                .then((res) => {
                    if (res.data.code == 200) {
                        this.userList = res.data.data
                    } else {
                        this.message405(res)
                    }
                })
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.resetUser();
            this.open = true;
            this.title = "添加購票人資訊";
        },
        /** 修改按钮操作 */
        updateUserForTicket(id) {
            this.resetUser();
            detailsBuyer({
                id
            }).then(res => {
                if (res.data.code == 200) {
                    this.formUser = res.data.data;
                } else {
                    this.message405(res)
                }
            });
            this.open = true;
            this.title = "修改購票人資訊";
        },
        // 选择购票人
        addUserForTicket(item) {
            this.$notify({
                title: '購票人添加成功',
                type: 'success',
                duration: 2000
            });
            this.cancelPopupUser()
            // 场次选择
            if (this.bookingInfoByMyTicket.ticketId) {
                this.currentBuyerInfo = item
                return
            }
        },
        /** 提交按钮 */
        submitForm() {
            this.$refs["formUser"].validate(valid => {
                if (valid) {
                    if (this.formUser.id !== undefined) {
                        editBuyer(this.formUser).then(res => {
                            if (res.data.code == 200) {
                                this.$notify({
                                    title: '修改成功',
                                    type: 'success',
                                    duration: 1000
                                });
                                this.open = false;
                                this.getList();
                            } else {
                                this.message405(res)
                            }
                        });
                    } else {
                        addBuyer(this.formUser).then(res => {
                            if (res.data.code == 200) {
                                this.$notify({
                                    title: '新增成功',
                                    type: 'success',
                                    duration: 1000
                                });
                                this.open = false;
                                this.getList();
                            } else {
                                this.message405(res)
                            }
                        });
                    }
                }
            });
        },
        /** 删除按钮操作 */
        removeUserForTicket(row) {
            this.$confirm('是否確認删除購票者姓名為"' + row.name + '"的資料項目?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delBuyer({
                    id: row.id
                }).then(() => {
                    this.getList();
                    this.$notify({
                        title: '删除成功',
                        type: 'success',
                        duration: 1000
                    });
                })
            })
        },
    }

}
</script>
<style lang="less">
.add-user-dialog {
    .el-dialog {
        width: 500px;
        max-width: 90%;
    }
}

.el-form-item__label {
    line-height: 40px;
}


.buy-content {
    width: 100%;
    min-height: 100vh;
    background-color: #000;
    padding: 20px 50px 110px;
    box-sizing: border-box;
    color: #fff;

    .btn-mobile {
        display: none;
    }

    .el-button--primary {
        background-color: #fff;
        border-color: #fff;
        color: #000;
    }

    .el-button--primary.is-plain {
        background-color: #000;
        border-color: #fff;
        color: #fff;
    }

    .el-button--primary:hover,
    .el-button--primary:focus {
        background-color: #fff;
        border-color: #fff;
        color: rgba(0, 0, 0, .8);
    }

    .el-button--primary.is-plain:hover,
    .el-button--primary.is-plain:focus {
        background-color: #000;
        border-color: rgba(255, 255, 255, .8);
        color: rgba(255, 255, 255, .8);
    }

    .el-form-item__label {
        color: #fff !important;
    }

    .active-calendar {
        margin-top: -22px !important;
    }

    .el-calendar {
        border: 2px solid #fff;
        box-shadow: 0 0 10px 1px #D4A3FF;
        border-radius: 10px;
        background-color: transparent !important;
        margin-bottom: 22px;

        .el-calendar__header {
            border: 2px solid #D4A3FF;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            background-image: linear-gradient(to right,
                    #D4A3FF 0%,
                    transparent 50%,
                    #D4A3FF 100%);
            box-shadow: 0 0 10px 1px #D4A3FF;
            padding: 0 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            min-height: 70px;

            .el-calendar__button-group {
                width: 100%;
                display: flex;
                order: 1;

                .el-button-group {
                    display: flex;
                    gap: 100px; // 左右箭头之间的间距
                    width: 100%;
                    justify-content: center;

                    // 隐藏"今天"按钮
                    button:nth-child(2) {
                        display: none !important;
                    }

                    // 上个月按钮
                    button:first-child {
                        background: transparent !important;
                        border: none !important;
                        box-shadow: none !important;
                        padding: 8px 12px !important;

                        span {
                            display: none;
                        }

                        &::before {
                            content: '';
                            display: inline-block;
                            width: 100px;
                            height: 50px;
                            background-image: url('../../assets/images/left.png');
                            background-size: contain;
                            background-repeat: no-repeat;
                            background-position: center;
                        }

                        &:hover::before {
                            opacity: 0.8;
                        }

                        // 禁用状态样式
                        &:disabled {
                            cursor: not-allowed !important;

                            &::before {
                                opacity: 0.3;
                            }

                            &:hover::before {
                                opacity: 0.3;
                            }
                        }
                    }

                    // 下个月按钮
                    button:last-child {
                        background: transparent !important;
                        border: none !important;
                        box-shadow: none !important;
                        padding: 8px 12px !important;

                        span {
                            display: none;
                        }

                        &::before {
                            content: '';
                            display: inline-block;
                            width: 100px;
                            height: 50px;
                            background-image: url('../../assets/images/right.png');
                            background-size: contain;
                            background-repeat: no-repeat;
                            background-position: center;
                        }

                        &:hover::before {
                            opacity: 0.8;
                        }

                        // 禁用状态样式
                        &:disabled {
                            cursor: not-allowed !important;

                            &::before {
                                opacity: 0.3;
                            }

                            &:hover::before {
                                opacity: 0.3;
                            }
                        }
                    }
                }
            }
        }

        .el-calendar-table {
            thead {
                th {
                    font-size: 0 !important; // 隐藏原有文字

                    &:nth-child(1)::before {
                        content: 'M';
                        font-size: 25px;
                        color: rgba(239, 240, 242, .5);
                        font-weight: bold;
                    }

                    &:nth-child(2)::before {
                        content: 'T';
                        font-size: 25px;
                        color: rgba(239, 240, 242, .5);
                        font-weight: bold;
                    }

                    &:nth-child(3)::before {
                        content: 'W';
                        font-size: 25px;
                        color: rgba(239, 240, 242, .5);
                        font-weight: bold;
                    }

                    &:nth-child(4)::before {
                        content: 'T';
                        font-size: 25px;
                        color: rgba(239, 240, 242, .5);
                        font-weight: bold;
                    }

                    &:nth-child(5)::before {
                        content: 'F';
                        font-size: 25px;
                        color: rgba(239, 240, 242, .5);
                        font-weight: bold;
                    }

                    &:nth-child(6)::before {
                        content: 'S';
                        font-size: 25px;
                        color: rgba(239, 240, 242, .5);
                        font-weight: bold;
                    }

                    &:nth-child(7)::before {
                        content: 'S';
                        font-size: 25px;
                        color: rgba(239, 240, 242, .5);
                        font-weight: bold;
                    }
                }
            }
        }

        .el-calendar__title {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
            font-size: 20px;
            font-weight: bold;
            margin: 0;
            white-space: nowrap;
            z-index: 0;
        }

        .el-calendar-table__row {

            td,
            tr {
                font-size: 20px;
                border: none !important;
            }

            td {
                padding: 5px;
                box-sizing: border-box;
            }

            // 高峰期边框样式
            .el-calendar-day:has(.custom-calendar-day[data-status="1"]),
            .el-calendar-day:has(.custom-calendar-day[data-status="3"]) {
                color: #fff;
            }

            // 高峰期边框样式
            .el-calendar-day:has(.custom-calendar-day[data-status="2"]) {
                border: 2px solid #FF8D1A;
            }

            .calendar-cell-wrapper {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                border-radius: 50%;
                transition: all 0.2s ease;
                -webkit-tap-highlight-color: transparent;
            }

            .is-selected {
                background-color: transparent !important;
            }

            .el-calendar-day:has(.custom-calendar-day[data-status="1"]):hover .calendar-cell-wrapper,
            .el-calendar-day:has(.custom-calendar-day[data-status="2"]):hover .calendar-cell-wrapper,
            .el-calendar-day:has(.custom-calendar-day[data-status="3"]):hover .calendar-cell-wrapper {
                border-radius: 50%;
                background-color: #D4A3FF !important;
                color: #000;
                box-shadow: 0 0 10px 1px #D4A3FF;
            }

            // 禁止状态
            .el-calendar-day:has(.disabled-date) .calendar-cell-wrapper {
                opacity: 0.5;
                cursor: not-allowed;
            }

            // 选中状态
            .calendar-cell-wrapper.selected-date {
                background-color: #D4A3FF !important;
                color: #000 !important;
                box-shadow: 0 0 10px 1px #D4A3FF;
                border-radius: 50%;
            }

            .current {
                color: rgba(239, 240, 242, .5) !important;

                .el-calendar-day {
                    border-radius: 50%;
                }

                .el-calendar-day:hover {
                    background-color: transparent !important;
                }
            }

            .prev,
            .next {
                color: rgba(239, 240, 242, .2) !important;

                .el-calendar-day:hover {
                    background-color: transparent !important;
                }
            }

            // 非当前月
            .prev .calendar-cell-wrapper,
            .next .calendar-cell-wrapper {
                background-color: rgba(49, 46, 51, .5);
                border-radius: 50%;
            }

            .prev:hover .calendar-cell-wrapper,
            .next:hover .calendar-cell-wrapper {
                background-color: transparent !important;
            }

            // 当前月非选中日期的背景
            .current .calendar-cell-wrapper:not(.selected-date) {
                border-radius: 50%;
                background-color: #312E33 !important;
            }

            // 选中状态的样式覆盖
            .is-selected .calendar-cell-wrapper.selected-date {
                background-color: #D4A3FF !important;
                color: #000;
                box-shadow: 0 0 10px 1px #D4A3FF;
                border-radius: 50%;
            }

            .el-calendar-day {
                width: 50px;
                height: 50px;
                font-weight: bold;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0 auto;
                padding: 0;
            }

            .custom-calendar-day {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
            }
        }
    }

    .calendar-tip {
        margin-top: -48px;
        display: flex;
        align-items: center;

        .tip-item {
            display: flex;
            align-items: center;
            font-size: 13px;
            margin-left: 30px;

            .tip-circle {
                margin-right: 5px;
            }
        }

        .tip-circle {
            width: 10px;
            height: 10px;
            border-radius: 50%;
        }

        .tip-circle:nth-child(1) {
            border: 2px solid #FF8D1A;
        }


        .tip-item:nth-child(1) {
            color: #FF8D1A;
        }
    }

    .page-background {
        position: fixed;
        right: 0;
        top: 0;
        bottom: 0;
        left: calc(50% + 20px);

        .page-background--shadow {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background: linear-gradient(to right, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0) 20%);
            z-index: 1;
        }

        .page-background--image {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            object-fit: cover;
        }
    }

    .dialog-footer {
        width: calc(40% + 30px);
        position: fixed;
        left: 0;
        bottom: 0;
        padding: 20px 20px 20px 50px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        background-color: #000;
        z-index: 100;

        .confirm-btn {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .totalMoney {
                font-size: 30px;
                font-weight: bold;
                margin-right: 20px;
            }
        }

        .el-button {
            width: 65%;
        }

        .return-btn {
            width: 30% !important;
        }
    }

    .title {
        width: 40%;
        height: auto;
    }

    .step-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;

        .step-item {
            width: 22%;

            img {
                width: 100%;
                height: auto;
            }
        }

        .step-item:nth-child(2n) {
            width: 4%;
        }

    }

    .session-group {
        width: 100%;

        .group-name {
            font-size: 20px;
            font-weight: bold;
            margin: 30px 0 40px;
        }

        .session-content {
            border: 2px solid #D4A3FF;
            border-radius: 10px;

            .session-list {
                display: flex;
                justify-content: space-between;
                height: 50px;
                border-bottom: 2px solid #D4A3FF;
                box-shadow: 0 0 10px 1px #D4A3FF;
                border-radius: 8px 8px 0 0;
                background-image: linear-gradient(to right, #D4A3FF 0%, transparent 50%, #D4A3FF 100%);

                .session-title {
                    width: 33%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;

                    .session-cn {
                        font-size: 18px;
                        font-weight: bold;
                    }

                    .session-en {
                        font-size: 13px;
                    }

                    // 第三个元素的 active 状态特殊处理
                    &:nth-child(3).active-session {
                        left: 0.4%;
                    }
                }

                .active-session {
                    position: relative;
                    left: -0.3%;
                    bottom: 39%;
                    height: 70px;
                    color: #000;
                    background-color: #D4A3FF;
                    border-radius: 8px 8px 0 0;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    .session-cn {
                        font-size: 20px;
                        font-weight: bold;
                    }

                    .session-en {
                        font-size: 15px;
                    }
                }
            }

        }

        .time-slot {
            padding: 10px 10px 20px;
            box-sizing: border-box;

            .tip-item {
                width: 100%;
                font-size: 13px;
                color: #FF78D9;

                .tip-text {
                    display: flex;
                    align-items: center;
                }

                .tip-circle {
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    margin-right: 5px;
                    border: 2px solid #FF78D9;
                }

                .tip-text:nth-child(1) {
                    color: #fff;
                }

            }

            .time-box {
                display: flex;
                flex-wrap: wrap;

                .time-item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    margin-top: 10px;
                    width: 32%;
                    border: 2px solid #D4A3FF;
                    border-radius: 50px;
                    height: 50px;
                    margin-right: 2%;
                    cursor: pointer;
                    box-sizing: border-box;

                    .time-text {
                        font-size: 15px;
                        color: #fff;
                        font-weight: 500;
                    }

                    .oversold {
                        font-size: 12px;
                    }

                    .recommend-stars {
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        .star-icon {
                            width: 12px;
                            height: auto;
                            transition: all 0.3s ease;

                            // 选中时变为黑色
                            &.star-active {
                                filter: brightness(0);
                            }
                        }
                    }
                }

                .time-item:nth-child(3n) {
                    margin-right: 0%;
                }

                .active-time {
                    background-color: #D4A3FF;

                    .time-text {
                        color: #000;
                    }
                }

                .oversold-time {
                    opacity: 0.5;
                    cursor: not-allowed;
                }

                .recommend-time {
                    border: 2px solid #FF78D9;

                    .time-text {
                        color: #FF78D9;
                    }
                }

                .time-item.active-time.recommend-time {
                    border: 2px solid #D4A3FF;

                    .time-text {
                        color: #000;
                    }
                }
            }
        }
    }

    .add-user {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 150px;
        height: 25px;
        box-shadow: 0 0 10px 1px #BA74F7;
        border-radius: 20px;
        font-size: 12px;
        cursor: pointer;
        margin: auto;
        margin-top: 20px;
        color: #BA74F7;

        .el-icon-circle-plus-outline {
            font-size: 15px;
        }
    }

    .add-user-list {
        display: flex;
        align-items: center;
        margin-top: 10px;

        .el-icon-remove-outline {
            margin-right: 10px;
            font-size: 20px;
            cursor: pointer;
        }

        .userInfo-box {
            width: 100%;

            .userInfo-number {
                width: 100%;
                display: flex;
                justify-content: space-between;
            }
        }
    }

    .ticket-content,
    .step-box {
        width: 40%;
        min-width: 300px;
    }

    .tip {
        width: 100%;
        color: #D53232;
        font-size: 13px;
    }

    .ticket-list {
        width: 100%;
        padding: 20px 0;
        box-sizing: border-box;

        .ticket-name {
            font-size: 20px;
            font-weight: bold;
        }

        .ticket-box {
            width: 100%;
            margin: 10px 0;
            min-width: 300px;
            padding: 10px 20px;
            box-sizing: border-box;
            border-radius: 10px;
            background-color: #fff;
            color: #000;
            position: relative;

            .ticket-display {
                width: 100%;
                height: 100%;
                display: flex;

                .half-circle {
                    position: absolute;
                    left: 0;
                    top: 45%;
                    margin: auto;
                    width: 100%;
                    display: flex;
                    justify-content: space-between;

                    .circle-right,
                    .circle-left {
                        width: 15px;
                        height: 30px;
                        background-color: #000;
                    }

                    .circle-right {
                        border-radius: 15px 0 0 15px;
                    }

                    .circle-left {
                        border-radius: 0 15px 15px 0;
                    }
                }

                .image {
                    width: 140px;
                    height: 100%;
                    object-fit: fill;
                    border-radius: 5px;
                }

                .ticket-right {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    font-size: 10px;
                    padding: 0 10px;
                    box-sizing: border-box;

                    .title {
                        width: 100%;
                        font-size: 20px;
                        font-weight: bold;
                    }

                    .ticket-detail {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .el-input-number__increase,
                        .el-input-number__decrease {
                            border-radius: 50%;
                            border: 2px solid #000;
                            color: #000;
                            font-size: 20px;
                            background-color: transparent;
                            -webkit-tap-highlight-color: transparent;

                            i {
                                font-weight: bold;
                            }
                        }

                        .el-input {
                            padding-left: 50px;
                            box-sizing: border-box;

                            .el-input__inner {
                                font-size: 30px;
                                color: #000;
                                border: none;
                                background-color: rgba(0, 0, 0, .1);
                                padding-left: 0 !important;
                                padding-right: 0 !important;
                                width: 90% !important;
                            }
                        }


                        .money {
                            font-size: 28px;
                            font-weight: bold;
                        }
                    }

                }

            }

        }

    }

    .nodata-tip {
        text-align: center;
        color: #606266;
        font-size: 12px;
    }

    .ticket-tip {
        margin-top: 20px;
    }

    .popup-content {
        width: 100%;
        height: 100vh;
        background-color: rgba(0, 0, 0, .5);
        z-index: 100;
        position: fixed;
        left: 0;
        top: 0;
        color: #000;

        .popup-box {
            width: 500px;
            height: 500px;
            max-width: 90%;
            background-color: #fff;
            border-radius: 15px;
            position: fixed;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            padding: 10px;
            box-sizing: border-box;

            .add-user {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 150px;
                height: 25px;
                border-radius: 20px;
                font-size: 12px;
                cursor: pointer;
                margin: auto;

                .el-icon-circle-plus-outline {
                    font-size: 15px;
                }
            }
        }

        .popup-user {
            overflow-y: auto;
        }

        .user-list {
            .user-singel {
                background-color: rgba(168, 168, 168, 0.1);
                margin-top: 10px;
                border-radius: 5px;
                padding: 10px;

                .user-info {
                    display: flex;
                    flex-wrap: wrap;
                    margin-bottom: 10px;

                    .user-tag {
                        margin-right: 5px;
                    }
                }

                .action-btn {
                    display: flex;
                    justify-content: flex-end;

                    .btn {
                        font-size: 12px;
                        border: 1px solid #000;
                        padding: 5px 10px;
                        border-radius: 5px;
                        margin-left: 5px;
                        cursor: pointer;
                    }
                }
            }
        }
    }
}

@media (max-width: 1200px) {
    .el-calendar {
        .el-calendar-day {
            width: 35px !important;
            height: 35px !important;
        }
    }

}

/* 响应式设计：在屏幕宽度小于 480px 时调整字体和布局 */
@media (max-width: 780px) {
    .buy-content {
        padding: 20px;
        padding-bottom: 110px;

        .btn-pc {
            display: none;
        }

        .btn-mobile {
            display: block;
        }

        .page-background {
            display: none;
        }

        .ticket-content,
        .step-box,
        .title {
            width: 100% !important;
        }


        .dialog-footer {
            width: 100%;
            padding: 20px;
            min-width: 300px;

        }

        .totalMoney {
            font-size: 20px !important;
        }

        .ticket-display .image {
            width: 100px !important;
        }

        .el-calendar {
            .el-calendar-day {
                font-size: 15px;
                width: 35px !important;
                height: 35px !important;
            }
        }

        .time-item {
            height: 40px !important;

            .time-text {
                font-size: 12px !important;
            }
        }


        .ticket-box {
            padding: 10px 20px !important;

            .circle-right,
            .circle-left {
                width: 15px !important;
                height: 30px !important;
            }

            .circle-right {
                border-radius: 15px 0 0 15px !important;
            }

            .circle-left {
                border-radius: 0 15px 15px 0 !important;
            }
        }

        .ticket-right {
            width: calc(100% - 100px) !important;

            .title {
                font-size: 15px !important;
            }

            .money {
                font-size: 20px !important;
            }
        }

        .session-title {
            .session-cn {
                font-size: 16px !important;
            }

            .session-en {
                font-size: 12px !important;
            }
        }

        .active-session {

            .session-cn {
                font-size: 18px !important;
            }

            .session-en {
                font-size: 14px !important;
            }
        }
    }

    .el-message-box {
        width: 300px !important;
    }

}
</style>